import { certifications } from "api/certified-api";

/**
 * Genera los encabezados comunes para las peticiones.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers estándar.
 */
const getHeaders = (token) => ({
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'x-access-token': token
});

/**
 * Obtiene todos los puntajes (scores) registrados de EMeT.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Lista de puntajes.
 */
export const fetchEmetScores = async (token) => {
	const response = await certifications.get(`/emet/scores`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene el puntaje (score) de EMeT asociado a una certificación específica.
 * @param {string|number} id - ID de la certificación.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Puntaje de la certificación.
 */
export const fetchEmetScoreCertificationById = async (id, token) => {
	const response = await certifications.get(`/emet/scores/certification/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};